"use strict";
/**
 * Markets Filters
 * Filter and sort functionality for markets
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getActiveMarkets = getActiveMarkets;
exports.sortBySpread = sortBySpread;
exports.sortByPrice = sortByPrice;
exports.getMarketById = getMarketById;
exports.filterMarketsByCategory = filterMarketsByCategory;
exports.getAvailableCategories = getAvailableCategories;
const cache_1 = require("./cache");
const constants_1 = require("./constants");
/**
 * Filter active/tradable markets
 */
function getActiveMarkets(markets) {
    const list = markets || (0, cache_1.getKalshiMarketCache)();
    return list.filter((market) => market.status === "active");
}
/**
 * Sort markets by bid-ask spread
 */
function sortBySpread(markets, ascending = true) {
    const sorted = [...markets].sort((a, b) => {
        const spreadA = a.ask - a.bid;
        const spreadB = b.ask - b.bid;
        return ascending ? spreadA - spreadB : spreadB - spreadA;
    });
    return sorted;
}
/**
 * Sort markets by price
 */
function sortByPrice(markets, ascending = true) {
    const sorted = [...markets].sort((a, b) => {
        const priceA = (a.bid + a.ask) / 2;
        const priceB = (b.bid + b.ask) / 2;
        return ascending ? priceA - priceB : priceB - priceA;
    });
    return sorted;
}
/**
 * Get market by ID
 */
function getMarketById(marketId, markets) {
    const list = markets || (0, cache_1.getKalshiMarketCache)();
    return list.find((market) => market.id === marketId);
}
/**
 * Filter markets by category
 */
function filterMarketsByCategory(markets, category) {
    const categoryKeywords = {
        [constants_1.MARKET_CATEGORIES.SPORTS]: [
            "NFL",
            "NBA",
            "MLB",
            "NHL",
            "MLS",
            "EPL",
            "sports",
            "game",
            "team",
            "score",
        ],
        [constants_1.MARKET_CATEGORIES.ELECTIONS]: [
            "election",
            "vote",
            "candidate",
            "party",
            "senate",
            "congress",
        ],
        [constants_1.MARKET_CATEGORIES.EVENTS]: [
            "event",
            "conference",
            "summit",
            "ceremony",
        ],
        [constants_1.MARKET_CATEGORIES.CRYPTOCURRENCY]: [
            "crypto",
            "bitcoin",
            "ethereum",
            "BTC",
            "ETH",
        ],
    };
    const keywords = categoryKeywords[category] || [];
    if (keywords.length === 0) {
        console.warn(`Unknown category: ${category}, returning all markets`);
        return markets;
    }
    return markets.filter((market) => {
        const searchText = `${market.title} ${market.subtitle}`.toLowerCase();
        return keywords.some((keyword) => searchText.includes(keyword.toLowerCase()));
    });
}
/**
 * Get available market categories from a list of markets
 */
function getAvailableCategories(markets) {
    const categories = new Set();
    markets.forEach((market) => {
        const title = `${market.title} ${market.subtitle}`.toLowerCase();
        Object.entries({
            sports: ["nfl", "nba", "mlb", "nhl", "mls", "epl", "sports"],
            elections: ["election", "vote", "candidate"],
            crypto: ["crypto", "bitcoin", "ethereum"],
        }).forEach(([cat, keywords]) => {
            if (keywords.some((kw) => title.includes(kw))) {
                categories.add(cat);
            }
        });
    });
    return Array.from(categories);
}
